import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { navItems, NavItem } from '../data/navigation';
type PendingPageProps = {
  item: NavItem;
};
export function PendingPage({
  item
}: PendingPageProps) {
  const otherPages = navItems.filter(nav => nav.path !== item.path);
  return <div className="w-full" data-id="element-192" data-mp="3so2mwlju35ox">
      <section className="border-b border-line" data-id="element-193" data-mp="3snssmlrracdf">
        <div className="mx-auto max-w-site px-6 py-20 lg:px-10 lg:py-28" data-id="element-194" data-mp="b82weut0jcdg">
          <nav aria-label="Fil d’Ariane" className="text-sm text-muted" data-id="element-195" data-mp="6akjyufsef0p">
            <Link to="/" className="hover:text-ink" data-id="element-196" data-mp="6cf3q5fbo137">
              Accueil
            </Link>
            <span className="mx-2" aria-hidden="true" data-id="element-197" data-mp="k7hkxopmdcvb">/</span>
            <span className="text-ink" data-id="element-198" data-mp="g9jtef8dmeor">{item.label}</span>
          </nav>
          <h1 className="mt-8 font-serif text-5xl leading-tight tracking-tight text-ink lg:text-6xl" data-id="element-199" data-mp="2m0nn52gb8smp">{item.label}</h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-200" data-mp="2i0n6db5qo5ch">{item.description}</p>

          <div className="mt-14 max-w-2xl border-l-2 border-accent bg-stone px-6 py-5" data-id="element-201" data-mp="2f5rgci2zrmfq">
            <p className="font-serif text-xl text-ink" data-id="element-202" data-mp="2k31hguzqtmje">Page en cours de rédaction</p>
            <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-203" data-mp="2p2e1l7z8cfia">
              Le contenu de cette rubrique sera publié prochainement. Pour toute demande, notre équipe reste
              joignable au 01 42 00 00 00.
            </p>
          </div>

          <Link to="/" className="mt-10 inline-flex items-center gap-2 border-b border-ink pb-1 text-[15px] text-ink hover:border-accent hover:text-accent" data-id="element-204" data-mp="2ysfm5psdjfsg">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-205" data-mp="37u6t0xynhsnw" />
            Retour à l’accueil
          </Link>
        </div>
      </section>

      <section aria-labelledby="autres-rubriques" className="mx-auto max-w-site px-6 py-16 lg:px-10" data-id="element-206" data-mp="1dfmgj8khh3fl">
        <h2 id="autres-rubriques" className="text-sm text-muted" data-id="element-207" data-mp="1idxmh87nqtsj">
          Autres rubriques
        </h2>
        <ul className="mt-6 grid border-t border-ink sm:grid-cols-2 lg:grid-cols-4" data-id="element-208" data-mp="1ad87dd274s3i">
          {otherPages.map(page => <li key={page.path} className="border-b border-line" data-id="element-209" data-mp="16dhgl9co6byz">
              <Link to={page.path} className="block py-5 font-serif text-xl text-ink hover:text-accent" data-id="element-210" data-mp="1kcgwnsm49ijj">
                {page.label}
              </Link>
            </li>)}
        </ul>
      </section>
    </div>;
}